import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AssignedLayer from "../components/AssignedLayer";

const AssignedPage = () => {
    return (
        <MasterLayout>
            {/* <div className="breadcrumb-with-buttons mb-20">
                <div className="d-flex align-items-center justify-content-between">
                    <h6 className="page-title mb-0">Assigned</h6>
                    <ul className="breadcrumb d-flex align-items-center gap-10">
                        <li className="breadcrumb-item">
                            <a href="#" className="text-secondary-light">
                                CRM
                            </a>
                        </li>
                        <li className="breadcrumb-item">
                            <a href="#" className="text-secondary-light">
                                Assigned
                            </a>
                        </li>
                    </ul>
                </div>
            </div> */}
            <AssignedLayer />
        </MasterLayout>
    );
};

export default AssignedPage;
